import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

// عدد الموظفين في الفترة + زر إقفال الشهر وخصم الأقساط (الإجماليات في البطاقات الملوّنة أعلاه).
export const PayrollTotals = ({ run, busy, onFinalize }) => {
  const { t } = useTranslation();
  return (
    <NeuCard className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Users className="h-5 w-5 text-primary" />
        <div>
          <p className="text-[10px] text-muted-foreground">{t("payroll.employees")}</p>
          <p className="font-mono text-lg font-black" data-testid="payroll-total-employees">
            {run ? run.employees : "—"}
          </p>
        </div>
      </div>
      <NeuButton variant="primary" data-testid="payroll-finalize" disabled={busy} onClick={onFinalize}>
        {t("payroll.finalize")}
      </NeuButton>
    </NeuCard>
  );
};
